import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import jsonExcel from '../node_modules/vue-json-to-excel'
import Snotify from 'vue-snotify'
import cloneDeep from 'lodash.clonedeep';

Vue.config.productionTip = false;

Date.prototype.GetFirstDayOfWeek = function () {
  return new Date(this.setDate(this.getDate() - this.getDay() + (this.getDay() == 0 ? -6 : 1)));
}
Date.prototype.GetLastDayOfWeek = function () {
  return new Date(this.setDate(this.getDate() - (this.getDay() == 0 ? 7 : this.getDay()) + 7));
}

Vue.prototype.$http = axios;
Vue.prototype.$moment = moment
Vue.prototype.$cloneDeep = cloneDeep;

// Object.defineProperty(Vue.prototype, '$_', { value: _ });

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.filter('formatFilename', function (value) {
  if (value) {
    let file = value.split('-');
    let ext = file.pop().split('.').pop();
    file = `${file.join('-')}.${ext}`;
    return file.length > 30 ? (file.substr(0, 27) + '...') : file
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatFullDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY - HH:mm:ss')
  }
})

Vue.filter('formatDay', function (value) {
  if (value) {
    return moment(String(value)).locale("bg").format('D MMMM')
  }
})

Vue.filter('formatDayOfWeek', function (value) {
  if (value) {
    return moment(String(value)).locale("bg").format('dddd')
  }
})

Vue.filter('formatDayYear', function (value) {
  if (value) {
    return moment(String(value)).locale("bg").format('D MMMM YYYY')
  }
})

const options = {
  toast: {
    timeout: 5000,
    showProgressBar: false
  }
}
Vue.use(Snotify, options)

// VUE COMPONENTS
Vue.component('downloadExcel', jsonExcel);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')